export const ApplyForJob = () => {
  let jobs = document.querySelectorAll("[data-apply]");
  if (jobs) {
    jobs.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        let textBox = document.getElementById("input_4_8");
        textBox.value = button.dataset.apply;
        const form = document.getElementById("gform_4");
        if (form) {
          form.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    });
  }
};
